import { http, HttpResponse } from 'msw';

import { apiRoutes } from '@features/users/adminPanel/consts/apiRoutes';
import { mockedAdvertiserInsertionOrdersData } from '@shared/mocks/requests/advertiserInsertionOrders/advertiserInsertionOrders.fixtures';

export const advertiserInsertionOrdersRequests = [
  http.get(`*${apiRoutes.getAdvertiserInsertionOrders()}`, () => {
    return HttpResponse.json(mockedAdvertiserInsertionOrdersData);
  }),
  http.post(`*${apiRoutes.postAdvertiserInsertionOrder()}`, () => {
    return HttpResponse.json({ success: true });
  }),
  http.put(`*${apiRoutes.putAdvertiserInsertionOrder(':id')}`, () => {
    return HttpResponse.json({ success: true });
  }),
];
